<template>
 <v-dialog v-model="show" persistent max-width="600px">
    <v-card>
            <v-card-title>
              <span class="headline">Skapa ett nytt ärende</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-flex>
                  <v-flex cols="12" sm="6" md="4">
                    <v-text-field
                      label="Elev"
                      hint="Skriv bara elevens initialer"
                      required
                      v-model="NewUser.name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex cols="12" sm="6" md="4">
                    <v-text-field
                      label="Kommentar"
                      hint="Detta kommer bli grunden för elevhälsoteamets arbete"
                      v-model="NewUser.steps[0].comment"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex cols="12" sm="6" md="4">
                    <v-select
                      :items="membernameandId"
                      item-text="[2]"
                      item-value="[1]"
                      label="Ägare av ärendet"
                      hint="Vem tror du är bäst lämpad som ägare av detta ärende. Kom ihåg att det alltid är läraren som äger elevproblematiken i klassrumssituation och elevhälsoteam är bara en resurs."
                      v-model="NewUser.shouldOwn"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex cols="12" sm="6">
                    <!-- {{classes}} -->
                    <v-select
                      v-model="NewUser.class"
                      :items="classes"
                      item-text="name"
                      item-value="id"
                      attach
                      chips
                      label="Klass"
                      hint="Vilken klass går eleven i?"
                      
                    ></v-select>
                    <div v-if="NewUser.hasOwnProperty('class')" >
                 <h1> Klassföreståndare:</h1>
   <v-btn 
      xs3
           v-for="mentor in classes.find(x => x.id === NewUser.class ).mentorIds"
        :key="mentor"
      class="mx-2"
      dark
      color="green ligthen-4"
    >
      {{ locfun.getName(
              mentor,
              teachernameandId,
              []
            )}}
    </v-btn>
                    </div>
                    <!-- {{   NewUser.hasOwnProperty('class') ?    locfun.getName(
               classes.find(x => x.id === NewUser.class ).mentorIds[0],
              teachernameandId,
              []
            ): ""
                      
                    }} -->
                    <!-- <v-select
                      v-model="NewUser.subscribersId"
                      :items="teachernameandId"
                      item-text="[0]"
                      item-value="[1]"
                      attach
                      chips
                      label="Prenumeranter"
                      hint="Vilka lärare vill bli uppdaterade på ärendet?"
                      multiple
                    ></v-select> -->
                  </v-flex>
                     <!-- <v-flex cols="12" sm="6">
                    <v-select
                      v-model="NewUser.mentor"
                      :items="teachernameandId"
                      item-text="[0]"
                      item-value="[1]"
                      attach
                      chips
                      label="Vem/vilka är elevens handledare"
                      multiple
                    ></v-select>
                  </v-flex> -->
                </v-flex>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn dark color="red darken-1" @click="show = false">
                Stäng
              </v-btn>
              <v-btn
                color="green lighten-1"
                text
                dark
                @click="Create_Case(NewUser)"
              >
                Skicka in anmälan
              </v-btn>
            </v-card-actions>
          </v-card>
 </v-dialog>
</template>
<script>
import { mapActions,mapGetters } from "vuex";
import fun from "../functions";
export default {
    name:"NewCase",

  computed: {
    ...mapGetters('classesAP', ['classes']),
    ...mapGetters('cases', ['status']),
    show: {
      get () {
        return this.value
      },
      set (value) {
         this.$emit('input', value)
      }
    }
  },

    created(){
    this.locfun = new fun();
    },
    props:{
        teachernameandId: Array,
        membernameandId: Array,
        id: String,
        schoolId: String,
        value: Boolean
    },
data() {
    return {
            NewUser: {
        // mentor: [],
        // class:
        // subscribersId: [this.id],
        schoolId: this.schoolId,
        steps: [{ ownerId: this.id, step: "Anmälan" }],
      },
      locfun: null,
    };
  },
    //   watch: {
    //     status: function (val) {
      
    //      if(val.type=="success")
    //     this.showSuccessSnackbar(val.text)
    //     else
    //     {
    //     this.showErrorSnackbar(val.text)
    //     }
    // },
    // },
  methods: {
         ...mapActions("cases", [
      "CreateCase" 
    ]),
             ...mapActions("teachers", [
      "addCase" 
    ]),
    ...mapActions(['showSuccessSnackbar','showErrorSnackbar']),

     Create_Case(NewUser) {
      this.CreateCase(NewUser)
      .then(res=> {
        //  (this.status)
        if(this.status.Type=="success")
       { this.showSuccessSnackbar(this.status.Text)
        this.addCase(NewUser)
        }
        else
        {
        this.showErrorSnackbar(this.status.Text)
        }
      })
       this.NewUser= {
        // mentor: [],
        // subscribersId: [this.id],
        schoolId: this.schoolId,
        steps: [{ ownerId: this.id, step: "Anmälan" }],
      },
      this.show = false;
    },
    
  }
}
</script>
<style >

</style>